import api from './api';

export const penalidadService = {
  // Obtener todas las penalidades
  getPenalidades: async (filtros = {}) => {
    try {
      const response = await api.get('/penalidades', { params: filtros });
      return response.data;
    } catch (error) {
      console.error('Error al obtener penalidades:', error);
      throw error;
    }
  },

  // Obtener penalidades por paciente
  getPenalidadesByPaciente: async (pacienteId) => {
    try {
      const response = await api.get(`/penalidades/paciente/${pacienteId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener penalidades del paciente:', error);
      throw error;
    }
  },

  // Obtener penalidad por ID
  getPenalidadById: async (id) => {
    try {
      const response = await api.get(`/penalidades/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener penalidad:', error);
      throw error;
    }
  },

  // Crear nueva penalidad
  crearPenalidad: async (data) => {
    try {
      const response = await api.post('/penalidades', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear penalidad:', error);
      throw error;
    }
  },

  // Actualizar penalidad
  actualizarPenalidad: async (id, data) => {
    try {
      const response = await api.put(`/penalidades/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar penalidad:', error);
      throw error;
    }
  },

  // Registrar pago de penalidad
  registrarPagoPenalidad: async (id, datosPago) => {
    try {
      const response = await api.post(`/penalidades/${id}/pago`, datosPago);
      return response.data;
    } catch (error) {
      console.error('Error al registrar pago de penalidad:', error);
      throw error;
    }
  },

  // Anular penalidad
  anularPenalidad: async (id, motivo) => {
    try {
      const response = await api.post(`/penalidades/${id}/anular`, { motivo });
      return response.data;
    } catch (error) {
      console.error('Error al anular penalidad:', error);
      throw error;
    }
  },

  // Obtener monto sugerido según tipo de penalidad
  getMontoSugerido: async (tipo) => {
    try {
      const response = await api.get(`/penalidades/monto-sugerido/${tipo}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener monto sugerido:', error);
      throw error;
    }
  }
};